import { gql } from '@utils/gpl-dedup';
import { taskFragment } from '@graphql/tasks/fragments';
import { paginatorInfoFragment } from '@graphql/fragments/paginatorInfo';

export const getTasks = gql`
  query tasks(
    $where: QueryTasksWhereWhereConditions
    $orderBy: [QueryTasksOrderByOrderByClause!]
    $first: Int!
    $page: Int
    $archived: Trashed
    $search: String
  ) {
    tasks(
      where: $where
      orderBy: $orderBy
      first: $first
      page: $page
      trashed: $archived
      search: $search
    ) {
      data {
        ...task
      }
      paginatorInfo {
        ...paginatorInfo
      }
    }
  }
  ${taskFragment}
  ${paginatorInfoFragment}
`;
